import { render, staticRenderFns } from "./list.vue?vue&type=template&id=11ba1338"
import script from "./list.vue?vue&type=script&lang=ts"
export * from "./list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/Cona-OSUM/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11ba1338')) {
      api.createRecord('11ba1338', component.options)
    } else {
      api.reload('11ba1338', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=11ba1338", function () {
      api.rerender('11ba1338', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dealers-addresses/list.vue"
export default component.exports